<template>
    <div class="exhibitions">
        <div class="exhibitionsBox">
            <div class="title">{{ $t('i18n_135') }}</div>
            <div class="listBox">
                <div v-for="item in list" :key="item.id" class="listItem">
                    <div class="leftDate">
                        <div class="leftTop">
                            <div class="date">{{ item.date }}</div>
                            <img v-if="item.upcoming == 1" class="upcoming" src="@/assets/index/upcoming.png" alt="">
                        </div>
                        <div class="address">{{ item.address }}</div>
                    </div>
                    <div class="rightInfo">
                        <img :src="item.cover" alt="" />
                        <div class="textInfo">
                            <div class="name">{{ item.title }}</div>
                            <div class="noBox">{{ item.desc1 }}</div>
                            <div class="address2">{{ item.desc2 }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { get_news_list } from "@/api/news"
export default {
    components: {

    },
    data() {
        return {
            list: [],
        }
    },
    created() {
        this.getList()
    },
    mounted() {

    },
    methods: {
        getList() {
            get_news_list().then(res => {
                this.list = res.data
            })
        },
    }
}
</script>

<style scoped lang="scss">
.exhibitions {
    background: #fff;
    padding-bottom: 119px;

    .exhibitionsBox {
        width: 1200px;
        margin: auto;

        .title {
            font-size: 40px;
            color: #000000;
            line-height: 40px;
            margin-bottom: 50px;
        }

        .listBox {
            .listItem {
                border-top: 1px solid #000000;
                padding: 30px 0;
                display: flex;

                &:nth-last-child(1) {
                    border-bottom: 1px solid #000000;
                }

                .leftDate {
                    width: 190px;
                    height: 140px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    flex-shrink: 0;

                    .leftTop {

                        .date {
                            font-size: 22px;
                            color: #000000;
                            line-height: 24px;
                        }

                        .upcoming {
                            width: 90px;
                            height: 20px;
                            vertical-align: bottom;
                            margin-top: 10px;
                        }
                    }

                    .address {
                        font-size: 20px;
                        color: #000000;
                        line-height: 24px;
                        font-weight: 300;
                    }
                }

                .rightInfo {
                    display: flex;
                    justify-content: space-between;
                    flex: 1;

                    img {
                        width: 280px;
                        height: 140px;
                        display: block;
                        object-fit: cover;
                    }

                    .textInfo {
                        width: calc(100% - 325px);

                        .name {
                            font-size: 22px;
                            color: #000000;
                            line-height: 24px;
                            height: 58px;
                            white-space: pre-wrap;
                            overflow: hidden;
                        }

                        .noBox {
                            font-weight: 300;
                            font-size: 20px;
                            color: #000000;
                            line-height: 24px;
                            margin-top: 16px;
                        }

                        .address2 {
                            font-weight: 300;
                            font-size: 20px;
                            color: #000000;
                            line-height: 24px;
                            margin-top: 18px;
                        }
                    }
                }
            }
        }
    }
}

@media screen and (max-width:1200px) {

    .exhibitions {
        padding-top: 100px;
        background: #fff;
        padding-bottom: 100px;

        .exhibitionsBox {
            width: 100%;
            margin: auto;

            .title {
                font-size: 24;
                color: #000000;
                line-height: 40px;
                margin-bottom: 50px;
                font-weight: bold;
                padding: 0 30px;
            }

            .listBox {
                .listItem {
                    border-top: 1px solid #000000;
                    padding: 30px 0;
                    display: flex;
                    flex-wrap: wrap;

                    &:nth-last-child(1) {
                        border-bottom: 1px solid #000000;
                    }

                    .leftDate {
                        display: none;

                        .leftTop {

                            .date {
                                font-size: 22px;
                                color: #000000;
                                line-height: 24px;
                            }
                        }

                        .address {
                            font-size: 20px;
                            color: #000000;
                            line-height: 24px;
                            font-weight: 300;
                        }
                    }

                    .rightInfo {
                        width: 100%;
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: space-between;


                        img {
                            width: 100%;
                            height: auto;
                            aspect-ratio: 2/1;
                            display: block;
                            object-fit: cover;
                        }

                        .textInfo {
                            width: 100%;
                            margin-top: 30px;
                            padding: 0 30px;

                            .name {
                                font-size: 22px;
                                color: #000000;
                                line-height: 24px;
                                height: 50px;
                            }

                            .noBox {
                                font-weight: 300;
                                font-size: 20px;
                                color: #000000;
                                line-height: 24px;
                                margin-top: 20px;
                            }

                            .address2 {
                                font-weight: 300;
                                font-size: 20px;
                                color: #000000;
                                line-height: 24px;
                                margin-top: 20px;
                            }
                        }
                    }
                }
            }
        }
    }

}
</style>